/**
 * Created by: cparaschiv
 * Date: 20.05.2013, 17:39
 */

(function(){
    'use strict';

    var READ = "read";

    var GridTransport = kendo.data.LocalTransport.extend({

        type: 'grid',
        _observableCollection: null,

        init: function(options) {
            var me = this;

            kendo.data.LocalTransport.fn.init.call(me, options);
        },

        cleanData: function(data){
            var isMapped, cleanData;

            isMapped = ko.mapping && data && data.__ko_mapping__;
            cleanData = data && isMapped ? ko.mapping.toJS(data) : ko.toJS(data);

            return cleanData || data;
        },

        setData: function(observableCollection){
            var me = this;

            me._observableCollection = observableCollection;
            me.data = me.cleanData(me._observableCollection);
        },

        read: function(options) {
            var me = this,
                isMapped, cleanData,
                data = this.data;

            cleanData = me.cleanData(data);

            options.success(cleanData);
        },

        update: function(options) {
            options.success(options.data);
        },

        create: function(options) {
            options.success(options.data);
        },

        destroy: function(options) {
            options.success(options.data);
        }
    });

    TS.GridTransport = GridTransport;
    $.extend(true, kendo.data.transports, {
        "grid": TS.GridTransport
    });

})();
